import { AnalysisMetrics } from "../types";
import { TRIAL_LIMITS } from "./config";
import { isTabUnlocked, TAB_MIN_LEVEL } from "./tabUnlockPolicy";

export type ViewMode = "SIMPLIFIED" | "STANDARD" | "EXPERT";

export interface MetricDefinition {
  id: string;
  key: keyof AnalysisMetrics;
  label: { fr: string; en: string };
  icon: string;
}

export const MASTER_METRICS: MetricDefinition[] = [
  { id: "rhythm",          key: "rhythm",          label: { fr: "MATCH",      en: "MATCH" },      icon: "⚔️" },
  { id: "harmony",         key: "harmony",         label: { fr: "ACCORDS",    en: "CHORDS" },     icon: "🎵" },
  { id: "synchronization", key: "synchronization", label: { fr: "FINESSE",    en: "FEEL" },       icon: "🛡️" },
  { id: "nuance",          key: "nuance",          label: { fr: "NUANCES",    en: "DYNAMICS" },   icon: "🌊" },
  { id: "posture",         key: "posture",         label: { fr: "VISION LAB", en: "VISION LAB" }, icon: "👁️" },
  { id: "cleanliness",     key: "cleanliness",     label: { fr: "PROPRETÉ",   en: "CLEAN" },      icon: "🔇" },
  { id: "tone",            key: "tone",            label: { fr: "TIMBRE",     en: "TONE" },       icon: "🎸" },
  { id: "articulation",    key: "articulation",    label: { fr: "ATTAQUE",    en: "ATTACK" },     icon: "⚡" },
  { id: "audio",           key: "quality_score",   label: { fr: "AUDIO LAB",  en: "AUDIO LAB" },  icon: "🎛️" },
];

/**
 * GESTIONNAIRE DE VISIBILITÉ
 * IMPORTANT : la visibilité = pédagogie/entitlement,
 * pas la preuve de données. La preuve de données = uiDataPolicy (NO=100%).
 */
export const getVisibleTabsForLevel = (
  levelId: number,
  analysisCount: number = 0,
  isPremium: boolean = false
): string[] => {
  const tabs = ["report"];

  const priority = [
    "rhythm",
    "harmony",
    "synchronization",
    "nuance",
    "posture",
    "cleanliness",
    "tone",
    "articulation",
    "audio",
  ];

  for (const id of priority) {
    if (!isTabUnlocked(levelId, id)) continue;

    // Gating Vision Lab trial
    if (id === "posture" && !isPremium && analysisCount >= TRIAL_LIMITS.VISION_LOCK_COUNT) continue;

    tabs.push(id);
  }

  return Array.from(new Set(tabs));
};

export const getRadarKeysForLevel = (
  levelId: number,
  analysisCount: number = 0,
  isPremium: boolean = false
): string[] => {
  // Radar = dimensions techniques, même verrouillées pédagogiquement
  // On exclut report/audio
  return Object.keys(TAB_MIN_LEVEL).filter(id => id !== "report" && id !== "audio");
};
